var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',_vm._b({attrs:{"color":!!_vm.channelProfile ? '' : '#FE1717'}},'v-avatar',_vm.$attrs,false),[(!!_vm.channelProfile)?_c('img',{attrs:{"src":_vm.channelProfile}}):_c('div',[_vm._v(_vm._s(_vm.channelName))])])}
var staticRenderFns = []

export { render, staticRenderFns }